<template>
  <div class="current-number-resource">
    <div v-show="title">
      <card-header :title="title" />
    </div>
    <div class="data-container">
      <div
        :class="data.length > 6 ? 'row-item' : 'row-item-less'"
        v-for="(item, index) in data"
        :key="index"
      >
        <template>
          <div>
            <div class="name">
              {{ item.name }}
            </div>
            <div class="show-item">
              <div v-if="item.name === 'rds慢查询率'">
                <countTo
                  v-if="item.number || item.number === 0"
                  :startVal="0"
                  :endVal="item.number"
                  :duration="2000"
                  :decimals="
                    item.number.toString().split('.')[1]
                      ? item.number.toString().split('.')[1].length
                      : 0
                  "
                  suffix="%"
                  :key="componentKey"
                ></countTo>
              </div>
              <div v-else>
                <countTo
                  :startVal="0"
                  :endVal="item.number"
                  :duration="2000"
                  :key="componentKey1"
                ></countTo>
              </div>

              <!-- {{ item.number || 0 }} -->
            </div>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>
<script>
import countTo from 'vue-count-to';
import CardHeader from './card-header.vue';

export default {
  props: {
    title: {
      type: String,
      default: '',
    },
    data: {
      type: Array,
      required: true,
      default: () => [],
    },
    isRefresh: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      componentKey1: 0,
      componentKey: 0,
      configData: {},
    };
  },
  components: {
    CardHeader,
    countTo,
  },
  watch: {
    isRefresh() {
      if (this.isRefresh) {
        // this.forceRerender();
        this.componentKey += 1;
        this.componentKey1 += 1;
      }
    },
  },
  methods: {
    // // 获取小数点位数
    // getDecimals(num) {
    //   return num?.toString().split('.')[1].length;
    // },
    forceRerender() {
      if (this.isRefresh) {
        this.componentKey += 1;
        this.componentKey1 += 1;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.current-number-resource {
  min-width: 470px;
  height: 273px;
  box-sizing: border-box;
  padding: 12px 14px;
  background-image: url("../../../assets/screen-adapter/最近7天供应商排名统计.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  .data-container {
    margin-top: 10px;
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
    .row-item {
      width: 141px;
      height: 64px;
      font-size: 12px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      background-image: url("../../../assets/screen-adapter/card-bg.png");
      background-size: 100% 100%;
      background-repeat: no-repeat;
      border-radius: 6px;
      &:nth-child(2),
      &:nth-child(5) {
        margin: 0 9.5px 9.5px;
      }
      &:nth-child(8) {
        margin: 0 9.5px 0;
      }
      .time {
        margin-bottom: 12px;
      }
      .hour {
        font-size: 27px;
        font-weight: bold;
        color: #1acfd7;
      }
      .name {
        padding-left: 5px;
        font-size: 18px;
        font-weight: bold;
        color: #1acfd7;
      }
      .show-item {
        margin-top: 7px;
        font-size: 18px;
        font-weight: bold;
        color: #fff;
      }
    }
    .row-item-less {
      width: 141px;
      height: 101px;
      font-size: 12px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      background-image: url("../../../assets/screen-adapter/card-bg.png");
      background-size: 100% 100%;
      background-repeat: no-repeat;
      border-radius: 6px;
      &:nth-child(2),
      &:nth-child(5) {
        margin: 0 9.5px 9.5px;
      }
      .name {
        padding-left: 5px;
        font-size: 18px;
        font-weight: bold;
        color: #1acfd7;
      }
      .show-item {
        margin-top: 14px;
        font-size: 18px;
        font-weight: bold;
        color: #fff;
      }
    }
  }
}
</style>
